import { render } from "./DraggableTreeNode.vue?vue&type=template&id=1274d475&scoped=true"
import script from "./DraggableTreeNode.vue?vue&type=script&lang=js"
export * from "./DraggableTreeNode.vue?vue&type=script&lang=js"

import "./DraggableTreeNode.vue?vue&type=style&index=0&id=1274d475&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1274d475"]])

export default __exports__